import {
  StatusChangedStrong,
  StatusChangedDivider,
  StatusChangedDividerWrapper,
  StatusChangedContentWrapper,
} from './Note.styled';
import { NotesContentProps } from './Notes.types';
import { formatDate } from 'src/utils/dateFns/formatDate';
import { getTimeAM_PM } from 'src/utils/dateFns/formatTime';

export const StatusChangedNote = ({ note, newStatus, ticketOwner }: NotesContentProps) => {
  const { month, day, year } = formatDate(new Date(note.createdon));
  const { hour, minutes, am_pm } = getTimeAM_PM(new Date(note.createdon));

  return (
    <StatusChangedDividerWrapper>
      <StatusChangedDivider appearance="brand" alignContent="center">
        <StatusChangedContentWrapper>
          <StatusChangedStrong>{ticketOwner} </StatusChangedStrong>
          changed status to
          <StatusChangedStrong>{newStatus} </StatusChangedStrong>
          on {`${month}/${day}/${year} at ${hour}:${minutes} ${am_pm}`}
        </StatusChangedContentWrapper>
      </StatusChangedDivider>
    </StatusChangedDividerWrapper>
  );
};
